import { BarData } from 'lightweight-charts';

/** Max digits for indicator inputs. Keeps values within JS safe integer range. */
export const INDICATOR_INPUT_MAX_DIGITS = 15;

export enum EChartType {
  ASSETS = 'ASSETS',
  MARKET = 'MARKET',
  PROFIT_LOSS = 'PROFIT_LOSS'
}

export enum EChartSource {
  WEB = 'WEB',
  MOBILEWEB = 'MOBILEWEB',
  MOBILEAPP = 'MOBILEAPP'
}

export enum EIndicatorConfigType {
  INPUT = 'INPUT',
  STYLE = 'STYLE'
}

export enum EIndicatorConfigFieldType {
  INPUT = 'inputFields',
  STYLE = 'styleFields'
}

export enum EChartLineSeriesDataType {
  ASK,
  BID
}

export interface ICustomBarData extends BarData {
  ask?: number;
}

export const mapIndicatorInputFieldType: Record<EIndicatorConfigType, EIndicatorConfigFieldType> = {
  [EIndicatorConfigType.INPUT]: EIndicatorConfigFieldType.INPUT,
  [EIndicatorConfigType.STYLE]: EIndicatorConfigFieldType.STYLE
};

export enum EChartSettingDismissActionType {
  CHART_COLOR_SETTING = 'CHART_COLOR_SETTING'
}
